import { Field } from 'formik';
import { FsProps, CustomSelectComponent, FormCol6 } from 'motion-components';
import React from 'react';

//1;field;technicianAssessment;enum('used','damaged','critically_damaged');;Αξιολόγηση από Τεχνίτη Υψηλής Τάσης;B.2;
export const FieldSelectBatteryCondition = ({
  label = 'Κατάσταση μπαταρίας;',
  name = 'xrbData.batteryCondition',
  as = 'div',
  ...rest
}: FsProps) => {
  const options = [
    { value: 'used', label: 'USED' },
    { value: 'damaged', label: 'DAMAGED' },
    { value: 'critically_damaged', label: 'CRITICALLY DAMAGED' },
  ];
  return (
    <Field
      name={name}
      title={label}
      component={(props) => <CustomSelectComponent {...props} as={as} className="mb-0" />}
      options={options}
      useCreatableSelect={true}
      {...rest}
    />
  );
};
